import { Button, Form, Modal, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProductPublish } from "../../../../api/products";

const UpdatePublish = ({
  isVisible,
  setVisible,
  is_published,
  productId,
}: any) => {
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: updateProductPublish,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["products", productId] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    const data = { is_published: !is_published };
    mutate({ product_id: productId, data });
  };

  const action = is_published ? "Unpublish" : "Publish";

  return (
    <Modal
      title={`${action} Product`}
      open={isVisible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="updateProductPublish"
          htmlType="submit"
          onSubmit={onSubmit}
          loading={isLoading}
          className="border-0 bg-blue-600 text-white"
        >
          {action}
        </Button>,
      ]}
    >
      <Form
        id="updateProductPublish"
        form={form}
        name="control-ref"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="">
          {is_published ? (
            <div className="">
              Are you Sure you want to{" "}
              <span className="text-red-600 text-bold">Unpublish</span> This
              Product
            </div>
          ) : (
            <div className="">
              Are you Sure you want to{" "}
              <span className="text-green-600 text-bold">Publish</span> This
              Product
            </div>
          )}
        </div>
      </Form>
    </Modal>
  );
};

export default UpdatePublish;
